// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-control__inner .a-input{display:flex;flex-flow:column}.map-control__inner .a-input button:not(:first-child){margin-top:-1px}.legend-items{max-width:unset!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
